import React, { useReducer, useEffect } from "react";
import { fetchGlobalData } from "../api";
import GlobalData from "./GlobalData";
import LocalData from "./LocalData";
import TopTenCases from "./TopTenCases";
const initialState = {
  loading: true,
  error: "",
  globalData: {},
  localData: {},
  lastUpdate: {},
};

const reducer = (state, action) => {
  switch (action.type) {
    case "FETCH_SUCCESS":
      return {
        loading: false,
        error: "",
        globalData: action.payload.globalData,
        localData: action.payload.localData,
        lastUpdate: action.payload.lastUpdate,
      };
    case "FETCH_ERROR":
      return {
        loading: false,
        error: "Sorry we couldn't find anthing " + action.payload.error,
        globalData: {},
        localData: {},
      };
    default:
      return state;
  }
};

function MainBody() {
  const [state, dispatch] = useReducer(reducer, initialState);
  useEffect(() => {
    fetchGlobalData()
      .then((response) => {
        dispatch({
          type: "FETCH_SUCCESS",
          payload: {
            globalData: response.data.Global,
            localData: response.data.Countries,
            lastUpdate: response.data.Date,
          },
        });
      })
      .catch((error) => {
        dispatch({
          type: "FETCH_ERROR",
          payload: {
            error,
          },
        });
      });
  }, []);
  const { loading, error, globalData, localData, lastUpdate } = state;
  if (error) {
    return (
      <div className="container m-5 p-5 text-danger">
        <h2>An error ocurred, please refresh the page</h2>
        {error}
      </div>
    );
  }
  return (
    <React.Fragment>
      {/*  Global Data Card */}
      <GlobalData
        MyGlobalData={globalData}
        LoadingState={loading}
        LastUpdate={lastUpdate}
      />
      {/*  Local Data Card */}
      <LocalData MyLocalData={localData} LoadingState={loading} />
      {/* Top Ten Countries with heighest cases  */}
      <TopTenCases MyLocalData={localData} LoadingState={loading} />
    </React.Fragment>
  );
}

export default MainBody;
